package fr.frux.core.common.push

/**
 * Pas de push sur cette cible : le web n'a pas de Service Worker dans l'app js Compose (ADR
 * 0007). Inerte plutôt qu'absent : l'écran de préférences n'a ainsi aucun `expect` à contourner,
 * il lit `supported`.
 */
private object NoOpPushRegistrar : PushRegistrar {
    override val supported: Boolean = false

    override fun permissionGranted(): Boolean = false

    override suspend fun ensureRegistered(): PushRegistrationResult = PushRegistrationResult.Unsupported

    override suspend fun unregister() = Unit
}

actual fun createPushRegistrar(sink: PushTokenSink): PushRegistrar = NoOpPushRegistrar
